import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { IRegistrationModuleProps } from '../../../interfaces/interfaces';
import Link from '../../elements/Link/Link';

function RegistrationModule(props: IRegistrationModuleProps): JSX.Element {
  const { headline, textContent } = props;
  const { t } = useTranslation();
  const doLogin = () => {
    // custom code executed outside of pc-app
    window.scrollTo(0, 0);
    if (!document.querySelector('.loginpanel #detail-link')?.classList.contains('active')) {
      document.querySelector('.loginpanel #detail-link')?.dispatchEvent(new CustomEvent('click'));
    }
    document.querySelector('.loginpanel #username2')?.dispatchEvent(new CustomEvent('focus'));
  };

  const doRegister = () => {
    if (!document.querySelector('.loginpanel #detail-link')?.classList.contains('active')) {
      document.querySelector('.loginpanel #detail-link')?.dispatchEvent(new CustomEvent('click'));
    }
    document.querySelector('.loginpanel .link.open-popup-link')?.dispatchEvent(new CustomEvent('click'));
  };

  return (
    <div className="tile-padding">
      <h2 className="hl-2">{headline}</h2>

      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: textContent || '' }} />

      <div className="button-group">
        <button className="link--button" onClick={doRegister} type="button">
          <span className="ic-arrowRight" />
          <span className="button-name">
            <Trans i18nKey="cockpit.registration.register">Jetzt registrieren</Trans>
          </span>
        </button>
        <Link
          linkText={t('cockpit.registration.login', { defaultValue: 'Jetzt Anmelden' })}
          ariaLabel={t('cockpit.registration.login', { defaultValue: 'Jetzt Anmelden' })}
          linkClass="link ic-arrowRight"
          onClick={doLogin}
        />
      </div>
    </div>
  );
}
export default RegistrationModule;
